(function () {
  const sliderSelector = '[data-miva-benefits-track]';
  const mobileMedia = window.matchMedia('(max-width: 499px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSlider(track) {
    if (track.dataset.mivaSliderReady === 'true') return;

    const section = track.closest('.miva-footer-benefits');
    const items = Array.from(track.children).filter((item) => !item.hidden);
    const dots = Array.from(section.querySelectorAll('[data-miva-benefits-dot]'));
    if (items.length < 2) return;

    track.dataset.mivaSliderReady = 'true';
    let currentIndex = 0;
    let autoplayTimer;
    let restartTimer;
    let scrollFrame;
    let isVisible = true;

    const setActiveDot = (index) => {
      currentIndex = Math.max(0, Math.min(index, items.length - 1));
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const goTo = (index, behavior = 'smooth') => {
      const normalizedIndex = (index + items.length) % items.length;
      track.scrollTo({ left: items[normalizedIndex].offsetLeft, behavior });
      setActiveDot(normalizedIndex);
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = undefined;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!mobileMedia.matches || reduceMotion.matches || !isVisible) return;
      autoplayTimer = window.setInterval(() => goTo(currentIndex + 1), 4600);
    };

    const pauseAfterInteraction = () => {
      stopAutoplay();
      window.clearTimeout(restartTimer);
      restartTimer = window.setTimeout(startAutoplay, 9000);
    };

    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        const closestIndex = items.reduce((bestIndex, item, index) => {
          const bestDistance = Math.abs(items[bestIndex].offsetLeft - track.scrollLeft);
          const currentDistance = Math.abs(item.offsetLeft - track.scrollLeft);
          return currentDistance < bestDistance ? index : bestIndex;
        }, 0);
        setActiveDot(closestIndex);
      });
    }, { passive: true });

    ['pointerdown', 'touchstart', 'wheel'].forEach((eventName) => {
      track.addEventListener(eventName, pauseAfterInteraction, { passive: true });
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(Number(dot.dataset.mivaBenefitsDot));
        pauseAfterInteraction();
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        isVisible = entries[0].isIntersecting;
        if (isVisible) startAutoplay();
        else stopAutoplay();
      }, { threshold: 0.35 });
      observer.observe(section);
    }

    const handleMediaChange = () => {
      if (!mobileMedia.matches) {
        stopAutoplay();
        track.scrollTo({ left: 0, behavior: 'auto' });
        setActiveDot(0);
      } else {
        startAutoplay();
      }
    };

    mobileMedia.addEventListener('change', handleMediaChange);
    reduceMotion.addEventListener('change', startAutoplay);
    startAutoplay();
  }

  function initAll(container) {
    container.querySelectorAll(sliderSelector).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
